module.exports = __webpack_public_path__ + "static/media/the_lost_tribe_bg2.0d23499a.jpg";